import { connect } from 'react-redux';

import ConfigureStyle from '../configureStyle.jsx';
import { actions } from '../../../../reducers/printers/printers';

const mapStateToProps = (state) => ({
  mode: 'import',
  title: 'Import Style Profile',
  printerTag: state.printers.currentPrinterTag,
  printers: state.printers.printers,
  parsedProfile: state.printers.parsedProfile,
  createStylesPending: state.printers.status.createStylesPending,
  requestSuccess: state.printers.status.createStylesSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  createStyleProfiles: (printerId, styles) =>
    dispatch(actions.createStyleProfilesRequest(printerId, styles)),
  resetParsedProfile: () => dispatch(actions.resetParsedProfile()),
  getPrinterTag: (tagId) => dispatch(actions.getPrinterTagRequest(tagId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureStyle);
